module.exports = __webpack_public_path__ + "img/yxkdiag3.dbdc87df.svg";